import { onDocumentLoaded } from "./helpers/utils"
import { addFilteringToAnchorMenuItems } from "./voyage-anchor-menu-filtering"

export function getUniqueTags() {
  const gridItems = document.querySelectorAll("[data-grid-item]")
  let arrayOfTags = []
  const arrayOfRemovableTags = window.NarrowTagFilters || []
  Array.prototype.slice.call(gridItems).forEach((gridItem) => {
    if (!gridItem.closest(".mixed-content")) {
      const tags = gridItem.dataset.tags
      if (tags) {
        const tagsDataString = tags.split(",")
        arrayOfTags = [...arrayOfTags, ...tagsDataString]
      }
    }
  })

  const uniqueTags = [...new Set(arrayOfTags)].filter(function (t) {
    return !arrayOfRemovableTags.includes(t)
  })

  return uniqueTags
}

export function populateAnchorMenuByTags() {
  const tags = getUniqueTags()
  const anchorMenu = document.querySelector("[data-anchor-menu]")

  const createAnchorMenuItem = (tagName) => {
    const menuItem = document.createElement("a")
    menuItem.className = "voyage__navigation-item"
    menuItem.dataset.tag = tagName
    menuItem.innerHTML = tagName
    if (anchorMenu) {
      anchorMenu.appendChild(menuItem)
    }
  }

  const sortedTags = tags.sort((prev, next) =>
    prev === next ? 0 : prev < next ? -1 : 1
  )
  sortedTags.forEach((tagName) => {
    createAnchorMenuItem(tagName)
  })

  addFilteringToAnchorMenuItems()
}

export default () => onDocumentLoaded(populateAnchorMenuByTags)
